"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var moment_1 = __importDefault(require("moment"));
var instructor_cancel_drive_controller_1 = __importDefault(require("./instructor-cancel-drive.controller"));
var instructor_cancel_drive_html_1 = __importDefault(require("./instructor-cancel-drive.html"));
function getDrive($stateParams, DrivesModel) {
    return DrivesModel.getDriveByID($stateParams.driveId).then(function (response) {
        var drive = response.drive;
        if (response.drive.status !== "Available" && response.drive.observation === false) {
            if (drive.student_id !== null) {
                var hasGuardian = drive.student.usermeta.filter(function (meta) {
                    return meta.meta_key === "guardian";
                });
                var parentMeta = void 0;
                if (hasGuardian.length === 1) {
                    parentMeta = hasGuardian[0].meta_value;
                    drive.student.guardian = JSON.parse(parentMeta);
                }
                drive.student.phone = drive.student.usermeta.filter(function (meta) {
                    return meta.meta_key === "phone";
                })[0].meta_value;
            }
        }
        if (response.drive.status !== "Available" && response.drive.observation === true) {
            response.drive.students = response.drive.students.map(function (student) {
                var hasGuardian = student.usermeta.filter(function (meta) {
                    return meta.meta_key === "guardian";
                });
                var parentMeta;
                if (hasGuardian.length === 1) {
                    parentMeta = hasGuardian[0].meta_value;
                    student.guardian = JSON.parse(parentMeta);
                }
                student.phone = student.usermeta.filter(function (meta) {
                    return meta.meta_key === "phone";
                })[0].meta_value;
                return student;
            });
        }
        drive.startTime = (0, moment_1.default)(drive.start_time, "HH:mm:s").format("h:mm a");
        var minutes = moment_1.default.duration(drive.session_length, "minutes");
        var endTimeMoment = (0, moment_1.default)(drive.start_time, "HH:mm:s").add(minutes, "minutes");
        drive.endTime = endTimeMoment.format("h:mm a");
        drive.duration = moment_1.default.duration(drive.session_length, "minutes").asHours();
        drive.duration = moment_1.default.duration(drive.duration, "hours").humanize();
        var driveDate = (0, moment_1.default)(drive.drive_date + " " + drive.start_time);
        // TODO: replace with drive.end
        var driveEnd = (0, moment_1.default)(drive.drive_date + " " + drive.start_time).add(minutes, "minutes");
        drive.inProgress = (0, moment_1.default)().isBetween(driveDate, driveEnd);
        // "now" is after the drive date
        drive.inPast = (0, moment_1.default)().isAfter(driveDate);
        return drive;
    });
}
getDrive.$inject = ["$stateParams", "DrivesModel"];
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
    $stateProvider.state("drivecoach.instructor.dashboard.canceldrive", {
        url: "/:driveId/cancel",
        controller: instructor_cancel_drive_controller_1.default,
        resolve: {
            driveSession: getDrive,
        },
        controllerAs: "vm",
        template: instructor_cancel_drive_html_1.default,
        data: {
            authorizedRoles: [
                USER_ROLES.admin,
                USER_ROLES.owner,
                USER_ROLES.instructor,
            ],
        },
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];
exports.default = angular_1.default
    .module("instructor.dashboard.canceldrive", [])
    .config(config)
    .controller("InstructorCancelDriveController", instructor_cancel_drive_controller_1.default);
